declare let window: any;

export const IS_PRODUCTION = window?.LOCAL_SETTINGS?.ENV === 'prod';
